var map = {
	"./NeueMachina-Ultrabold.woff2": 2871,
	"./PP-Migra-Italic-Extrabold-Italic.ttf": 536,
	"./PPNeueMachina-Regular.otf": 1529,
	"./achievements/a1.webp": 6284,
	"./achievements/a2.webp": 6953,
	"./achievements/d1.webp": 4593,
	"./achievements/d10.webp": 6271,
	"./achievements/d11.webp": 1980,
	"./achievements/d12.webp": 8841,
	"./achievements/d13.webp": 4334,
	"./achievements/d14.webp": 691,
	"./achievements/d15.webp": 640,
	"./achievements/d2.webp": 9348,
	"./achievements/d3.webp": 3527,
	"./achievements/d4.webp": 7898,
	"./achievements/d5.webp": 5429,
	"./achievements/d6.webp": 6024,
	"./achievements/d7.webp": 3963,
	"./achievements/d8.webp": 1086,
	"./achievements/d9.webp": 5769,
	"./achievements/e1.webp": 4664,
	"./editor.webp": 3860,
	"./favicon.png": 7514,
	"./icons/arrow.svg": 7190,
	"./icons/behance.svg": 5805,
	"./icons/close.svg": 5837,
	"./icons/fillStar.svg": 9972,
	"./icons/github.svg": 7394,
	"./icons/grid.svg": 3591,
	"./icons/line.svg": 8361,
	"./icons/logo.svg": 6962,
	"./icons/open.svg": 1975,
	"./icons/strokeStar.svg": 2311,
	"./icons/telegram.svg": 830,
	"./icons/vk.svg": 854,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./management.png": 1069,
	"./project1.mp4": 5008,
	"./project1.webm": 9360,
	"./project2.mp4": 1911,
	"./project2.webm": 2285,
	"./project3.webp": 7307,
	"./project4.mp4": 9289,
	"./project4.webm": 9779,
	"./project6.webp": 4356,
	"./project7.mp4": 1702,
	"./project7.webm": 1858,
	"./project8.mp4": 8157,
	"./project8.webm": 6599,
	"./project9.mp4": 6168,
	"./project9.webm": 4856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;